import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.grey100};
  min-height: calc(100vh - 50px);
  padding: 16px;
`;

export const ContainerTitle = styled(typography.MediumTitleTypography)`
  margin-top: 0;
  margin-bottom: 16px;
`;

export const Center = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
`;

export const Category = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.white};
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey200};
  cursor: pointer;
`;

export const CategoryIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0px;
  border-radius: 4px;
  margin-inline-end: 15px;
  &:before {
    content: ${({ icon }) => icon};
    font-family: icomoon;
    font-size: 22px;
    color: ${({ theme }) => theme.colors.grey600};
  }
`;

export const ArrowIcon = styled.div`
  margin-left: auto;
  transform: rotate(-90deg);
  &:before {
    content: '\\e913';
    font-family: icomoon;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.grey600};
  }
`;

export const CategoryContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(typography.TitleTwoTypography)`
  color: ${({ theme }) => theme.colors.grey600};
  margin: 0;
`;

export const SubTitle = styled(typography.BodyTextTwoRegularTypography)`
  color: ${({ theme }) => theme.colors.grey002};
  margin: 0;
`;
